import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PasswordInput } from '../components/PasswordInput';

export function LoginPage() {
  const { signIn, isLoading, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    try {
      await signIn(email, password);
      // signIn resolves user synchronously via resolveUser, so isAdmin isn't
      // updated yet in this render. Check email pattern instead:
      const isAdminEmail = email.toLowerCase().includes('administrator');
      navigate(isAdminEmail ? '/admin' : '/my-matches');
    } catch (err: any) {
      setError(err?.message ?? 'Přihlášení se nezdařilo');
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-default)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
    }}>
      <div className="login-container" style={{ maxWidth: '440px', width: '100%' }}>
        <div className="login-card">
          <div className="header-logo-text" style={{
            textAlign: 'center',
            fontSize: '2rem',
            lineHeight: 1.15,
            marginBottom: '2rem',
          }}>
            UNI <span className="accent">2026</span>
            <br />
            MATCH PLAY
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {error && <div className="login-error">{error}</div>}

            <div>
              <label htmlFor="login-email" style={{ textAlign: 'center', display: 'block' }}>E-mail</label>
              <input
                id="login-email"
                className="input"
                type="email"
                placeholder="jmeno.prijmeni@unimatchplay.golf"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
                style={{ textAlign: 'center' }}
              />
            </div>

            <div>
              <label htmlFor="login-password" style={{ textAlign: 'center', display: 'block' }}>Heslo</label>
              <PasswordInput
                id="login-password"
                className="input"
                placeholder="••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                style={{ textAlign: 'center' }}
              />
            </div>

            <button
              className="btn btn-accent btn-lg w-full"
              type="submit"
              disabled={isLoading}
              style={{ marginTop: '0.75rem' }}
            >
              {isLoading ? 'Přihlašování...' : 'Přihlásit se'}
            </button>
          </form>

          <div style={{ marginTop: '1.5rem', fontSize: '0.75rem', color: 'var(--text-muted)' }}>
            Přihlašovací údaje obdržíte od organizátora
          </div>

          <button
            className="btn btn-ghost mt-md"
            onClick={() => navigate('/')}
            style={{ width: '100%' }}
          >
            ← Zpět na program
          </button>
        </div>
      </div>
    </div>
  );
}
